import React, { Component } from 'react';

import { getIcon } from '../../../util/icons';

class DoGoal extends Component {

  goalValueAsNumber(){
    const { goalValue } = this.props.goal;

    if(!goalValue){
      return 0;
    }

    let goalValueAsNumber = 0;

    goalValueAsNumber += goalValue.practiced ? 1 : 0;
    goalValueAsNumber += goalValue.applied ? 1 : 0;
    goalValueAsNumber += goalValue.improved ? 1 : 0;

    return goalValueAsNumber;
  }

  getGoalProps(){
    const { goalValue } = this.props.goal;

    if(!goalValue || goalValue === ''){
      return {
        status: 'blank',
      }
    }
    else if(this.goalValueAsNumber() > 0){
      return {
        status: 'good',
      }
    }
    else{
      return {
        status: 'blank',
      }
    }
  }

  getGoalDisplayValue(){
    const goalValueAsNumber = this.goalValueAsNumber();

    if(goalValueAsNumber > 0){
      return `${goalValueAsNumber}/3`;
    }
    else if(this.props.editable){
      return getIcon('check');
    }
    else{
      return getIcon('cancel');
    }
  }

  renderGoalName(){
    const goal = this.props.goal
    const name = goal.name;

    return (
      <div
        className="description actionable"
        onClick={() => { this.props.trackGoal(goal); }}
      >{name}<span className="actionable-prompt">{getIcon('plan')}</span></div>
    );
  }

  render(){

    const { description, goalValue, name } = this.props.goal;

    const goalHasMetaForDefintionOrActionPlan = this.props.goal.goalMeta && (this.props.goal.goalMeta.successDefinition || this.props.goal.goalMeta.actionPlan);

    const goalProps = this.getGoalProps();

    const editableClass = this.props.editable ? 'editable' : '';

    return (
      <div
        onClick={e => { this.props.trackGoal(this.props.goal); e.stopPropagation(); return false; } }
        className={`goal do ${goalProps.status} ${editableClass}`}
      >
        {this.renderGoalName()}
        <div className={`checkbox ${editableClass} ` + ( this.goalValueAsNumber() > 0 ? ' checked' : '' )}>
          <span>{this.getGoalDisplayValue()}</span>
        </div>
      </div>
    );
  }
}

export default DoGoal;



// WEBPACK FOOTER //
// ./src/components/sprint/goalTemplates/doGoal.js